import {FormConfig} from "../../form/form.config";
import {FormModel} from "../../form/form.model.abstract";
import {FormModelDates} from "../../form/form.model.dates";
import {Form, UntypedFormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FormModelRadio} from "../../form/form.model.radio";
import {FormModelText} from "../../form/form.model.text";
import {ValidationService} from "../../services/validation.service";
import {FormModelSelect} from "../../form/form.model.select";
import {FormModelHidden} from "../../form/form.model.hidden";
import {FormModelNumber} from "../../form/form.model.number";
import {FormModelTextSelect} from "../../form/form.model.textselect";
import {FormModelPercent} from "../../form/form.model.percent";
import {HeizcheckConstants} from "../heizcheck.constants";
import {VerbrauchsanalyseForm} from "../../verbrauchsanalyse/verbrauchsanalyse.form";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {ModeratConstants} from "../../moderat/moderat.constants";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";

export class HeizkostenabrechnungForm extends FormConfig {

  /**
   * the warning for the case that cold water is needed as input.
   */
  public static readonly WARNING_COLDWATER = 'possibly_cold_water_costs_included';

  /**
   * Warning in case the energy price ist to low.
   */
  public static readonly WARNING_ENERGYPRICE = 'energy_price_too_low';

  /**
   * holds the current anfrage object with the users input
   */
  anfrage: HeizcheckAnfrage;

  /**
   * @inheritDoc
   * @protected
   */
  protected fields: FormModel[] = [
    // general
    new FormModelDates('abrechnungszeitraum',['abrechnung_von', 'abrechnung_bis'], [Validators.required, ValidationService.dateFormat],  null, [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], true),
    new FormModelRadio('nutzungszeitraum', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('nutzergruppen', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('messdienstleister', ['bfw', 'brunata', 'ista', 'kalo', 'minol', 'techem', 'sonstige'], [Validators.required], null, 'nein', false),

    // building
    new FormModelText('postleitzahl', [Validators.required, ValidationService.postalCode], null, null, false),
    (new FormModelText('gebaeudebaujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).activateToggle(),
    (new FormModelSelect('gebaeude_baualtersklasse_nutzerangabe', ['1983', '1984-1994', '1995-2001', '2002'], [Validators.required], null, '', false)).activateToggle().setInactive(),
    new FormModelText('gebaeude_flaeche', [Validators.required, Validators.min(ValidationService.BUILDING_AREA_MULTI_FAMILY.min), Validators.max(ValidationService.BUILDING_AREA_MULTI_FAMILY.max)], 'm2', null, true, 'number'),
    // new FormModelHidden('gebaeude_typ', 'mehrfamilienhaus'),
    new FormModelHidden('gebaeude_keller_beheizt', 'nein'),

    // apartement
    new FormModelRadio('wohnung_etage', ['erdgeschoss', 'zwischengeschoss', 'obergeschoss', 'dachgeschoss'], [Validators.required], null, null, false),
    (new FormModelRadio('gebaeude_dachgeschoss_ausgebaut', ['ja', 'nein'], [Validators.required], null, null, false)).setInactive(),
    new FormModelRadio('wohnung_anzahl_aussenwaende', [1, 2, 3, 4], [Validators.required], null, null, false),
    new FormModelNumber('bewohneranzahl', [Validators.required, Validators.min(1), Validators.max(HeizcheckConstants.FLAT_PEOPLE_MAX), ValidationService.allowIntegerOnly],  null, 1, false),
    new FormModelText('wohnung_flaeche', [Validators.required, Validators.min(HeizcheckConstants.FLAT_AREA_MIN), Validators.max(HeizcheckConstants.FLAT_AREA_MAX)], 'm2', null, true, 'number'),
    new FormModelNumber('gebaeude_stockwerke', [Validators.required, Validators.min(ModeratConstants.FORM_FLOOR_MIN_MFH), Validators.max(ModeratConstants.FORM_FLOOR_MAX_MFH), ValidationService.allowIntegerOnly],  null, ModeratConstants.FORM_FLOOR_MIN_MFH, false),

    // heating
    // new FormModelHidden('heizung_typ', 'zentral'),
    new FormModelSelect('energietraeger_name', ['erdgas', 'heizoel', 'fernwaerme', 'holzpellets', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser'], [Validators.required]),
    new FormModelText('energietraeger_kosten', [Validators.required, ValidationService.greaterZero],  'eur', null, true, 'number'),
    new FormModelTextSelect('energietraeger_verbrauch', 'energietraeger_einheit', [Validators.required, ValidationService.greaterZero],  ['kwh', 'mwh', 'gj', 'liter', 'm3', 'kg', 't', 'm3_kondens', 't_dampf'], [], true, 'number'),
    new FormModelText('gebaeude_heizkosten_raumwaerme', [Validators.required],  'eur', null, true, 'number'),
    new FormModelPercent('prozent_raumwaerme', ['prozent_grundkosten_raumwaerme', 'prozent_verbrauchskosten_raumwaerme'], [Validators.required], [30, 70]),

    new FormModelText('gebaeude_verbrauchseinheiten', [Validators.required], null, null, true, 'number'),
    new FormModelText('wohnung_verbrauchseinheiten', [Validators.required], null, null, true, 'number'),
    new FormModelText('wohnung_heizkosten_raumwaerme', [Validators.required], 'eur', null, true, 'number'),
    new FormModelText('wohnung_heizkosten_warmwasser', [Validators.required], 'eur', null, true, 'number'),
    new FormModelText('wohnung_grundkosten_raumwaerme', [Validators.required], 'eur', null, true, 'number'),
    new FormModelText('wohnung_verbrauchskosten_raumwaerme', [Validators.required], 'eur', null, true, 'number'),

    // hot water
    new FormModelRadio('warmwasser_bereitungsart', ['zentral', 'dezentral'], [Validators.required], null, null, false),
    new FormModelText('warmwasser_verbrauch', [Validators.required],  'm3', null, true, 'number'),
    new FormModelHidden('warmwasser_einheit', 'm3'),
    new FormModelText('wohnung_warmwasser_verbrauch', [Validators.required],  'm3', null, true, 'number'),
    new FormModelHidden('wohnung_warmwasser_einheit', 'm3'),
    new FormModelText('gebaeude_heizkosten_warmwasser', [Validators.required],  'eur', null, true, 'number'),
    new FormModelPercent('prozent_warmwasser', ['prozent_grundkosten_warmwasser', 'prozent_verbrauchskosten_warmwasser'], [Validators.required], [30, 70]),
    new FormModelText('wohnung_grundkosten_warmwasser', [Validators.required], 'eur', null, true, 'number'),
    new FormModelText('wohnung_verbrauchskosten_warmwasser', [Validators.required], 'eur', null, true, 'number'),
    new FormModelRadio('zusatzheizung_vorhanden', ['ja', 'nein', 'keine_angabe'], [Validators.required], null, 'keine_angabe', true),

    // addtional costs
    new FormModelRadio('heiznebenkosten_messgeraet_art', ['verdunster', 'elektronisch', 'waermezaehler'], [Validators.required], null, null, false),
    new FormModelRadio('heiznebenkosten_messgeraet_gemietet', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('heiznebenkosten_messgeraet_art_funk', ['nein', 'raumwaerme_warmwasser', 'raumwaerme', 'warmwasser'], [Validators.required], null, null, false),
  ];

  /**
   * @inheritDoc
   * @protected
   */

  protected formValidators = [
    ...['', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(index => ValidationService.smallerEqual('energietraeger_kosten' + index, 'heizkosten_gesamt' + index)),
    ValidationService.dateRangeMinMax('abrechnung_von', 'abrechnung_bis', HeizcheckConstants.INVOICE_MIN_DAYS, HeizcheckConstants.INVOICE_MAX_DAYS, ['', '1', '2', '3', '4', '5', '6', '7', '8', '9']),
    ValidationService.dateInPast('abrechnung_bis', HeizcheckConstants.INVOICE_MIN_DAYS_IN_PAST),
    ValidationService.validateInvoiceDates(),
    HeizkostenabrechnungForm.dateAfterBuildingYear(this)
  ];

  formValidatorsFields = {dateOverlapp: ['abrechnung_von', 'abrechnung_bis'], dateRangeMinMax: ['abrechnung_von', 'abrechnung_bis'], smallerEqual: ['energietraeger_kosten', 'heizkosten_gesamt']};

  protected groups = {
    'basisdaten/1': ['nutzungszeitraum'],
    'basisdaten/2': ['nutzergruppen'],
    'basisdaten/3': ['gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe'],
    'basisdaten/4': ['postleitzahl'],
    'basisdaten/5': ['bewohneranzahl'],
    'basisdaten/6': ['wohnung_etage', 'gebaeude_dachgeschoss_ausgebaut', 'wohnung_anzahl_aussenwaende'],
    'basisdaten/7': ['messdienstleister'],
    'basisdaten/8': ['warmwasser_bereitungsart'],
    'basisdaten/9': ['gebaeude_stockwerke'],

    'verbrauchseingabe': ['abrechnungszeitraum', 'energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten', 'gebaeude_flaeche', 'warmwasser_verbrauch', 'warmwasser_einheit'],
    'kostendetails': ['gebaeude_heizkosten_raumwaerme', 'gebaeude_heizkosten_warmwasser', 'prozent_raumwaerme', 'prozent_warmwasser', 'wohnung_flaeche',
      'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit', 'gebaeude_verbrauchseinheiten', 'wohnung_verbrauchseinheiten', 'wohnung_heizkosten_raumwaerme', 'wohnung_heizkosten_warmwasser'],

    'sonstiges/1': ['heiznebenkosten_messgeraet_art'],
    'sonstiges/2': ['heiznebenkosten_messgeraet_art_funk'],
    'sonstiges/3': ['heiznebenkosten_messgeraet_gemietet'],
  };

  constructor(protected energyMapService: EnergyMapService) {
    super();
  }

  /**
   * validates start date 'abrechnung_von' after the building year.
   * @param formConfig
   */
  static dateAfterBuildingYear(formConfig: HeizkostenabrechnungForm): ValidatorFn {
    return(formGroup: UntypedFormGroup) => {
      //check if there is a value in the field 'abrechnung_von'
      if(formGroup?.controls?.abrechnung_von?.value) {
        const buildingYear = formConfig?.anfrage?.heizkostenanalyseInput?.gebaeudebaujahr;
        const startDate = formGroup?.controls?.abrechnung_von?.value;

        //check if there is a value of buildingYear and abrechnung_von
        if(buildingYear && formGroup?.controls?.abrechnung_von?.value) {
          const startYear = ValidationService.dateFromString(startDate)?.getFullYear();

          //validate if the startYear from abrechnung_von is after the buildingYear
          if(startYear && startYear < buildingYear) {
            return {dateAfterBuildingYear: false};
          }
        }
      }
      return null;
    }
  }

  /**
   * Severeal groups configs because the field order and the groups changes from msp to msp. This is used to sort the fields and add subheadlines between the fields.
   * @see updateGroups()
   * @protected
   */
  groupsConfig: any = {
    /* default = techem */
    'default': {
      // basis: ['bewohneranzahl', 'wohnung_lage', 'warmwasser_bereitungsart', 'postleitzahl',  'gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe', 'abrechnungszeitraum', 'nutzungszeitraum'],
      anteil_gesamtkosten: ['prozent_raumwaerme', 'prozent_warmwasser','gebaeude_flaeche', 'wohnung_flaeche', 'gebaeude_verbrauchseinheiten', 'wohnung_verbrauchseinheiten',
        'wohnung_grundkosten_raumwaerme', 'wohnung_verbrauchskosten_raumwaerme', 'warmwasser_verbrauch', 'warmwasser_einheit', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit', 'wohnung_grundkosten_warmwasser', 'wohnung_verbrauchskosten_warmwasser', 'wohnung_heizkosten_raumwaerme', 'wohnung_heizkosten_warmwasser'],
      kosten_aufteilung: ['energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten', 'gebaeude_heizkosten_gesamt'],
      trennung_gesamtkosten: ['gebaeude_heizkosten_raumwaerme', 'gebaeude_heizkosten_warmwasser'],
      other: ['warmwasser_messung', 'heiznebenkosten_messgeraet_art', 'heiznebenkosten_messgeraet_gemietet', 'heiznebenkosten_messgeraet_art_funk', 'warmwasser_temperatur',
        'gebaeude_grundkosten_raumwaerme', 'gebaeude_verbrauchskosten_raumwaerme', 'gebaeude_grundkosten_warmwasser',
        'gebaeude_verbrauchskosten_warmwasser']
    },
    'ista': {
      // basis: ['bewohneranzahl', 'wohnung_lage', 'warmwasser_bereitungsart', 'postleitzahl',  'gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe', 'abrechnungszeitraum', 'nutzungszeitraum'],
      aufstellung_gesamkosten: ['energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten', 'gebaeude_heizkosten_gesamt'],
      aufteilung_gesamkosten: ['prozent_raumwaerme', 'prozent_warmwasser', 'gebaeude_heizkosten_raumwaerme', 'gebaeude_heizkosten_warmwasser', 'gebaeude_flaeche', 'wohnung_flaeche', 'gebaeude_verbrauchseinheiten', 'wohnung_verbrauchseinheiten',
        'wohnung_grundkosten_raumwaerme', 'wohnung_verbrauchskosten_raumwaerme', 'warmwasser_verbrauch', 'warmwasser_einheit', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit', 'wohnung_grundkosten_warmwasser', 'wohnung_verbrauchskosten_warmwasser', 'wohnung_heizkosten_raumwaerme', 'wohnung_heizkosten_warmwasser'],
      other: ['warmwasser_messung', 'heiznebenkosten_messgeraet_art', 'heiznebenkosten_messgeraet_gemietet', 'heiznebenkosten_messgeraet_art_funk', 'warmwasser_temperatur',
        'gebaeude_grundkosten_raumwaerme', 'gebaeude_verbrauchskosten_raumwaerme', 'gebaeude_grundkosten_warmwasser',
        'gebaeude_verbrauchskosten_warmwasser']
    },
    'brunata': {
      // basis: ['bewohneranzahl', 'wohnung_lage', 'warmwasser_bereitungsart', 'postleitzahl',  'gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe', 'abrechnungszeitraum', 'nutzungszeitraum'],
      aufstellung_kosten: ['energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten'],
      aufteilung_kosten: ['prozent_warmwasser', 'prozent_raumwaerme', 'gebaeude_heizkosten_warmwasser', 'gebaeude_heizkosten_raumwaerme',
        'warmwasser_verbrauch', 'warmwasser_einheit', 'gebaeude_flaeche', 'gebaeude_verbrauchseinheiten', 'gebaeude_heizkosten_gesamt'],
      ihre_kosten: ['wohnung_flaeche', 'wohnung_verbrauchseinheiten', 'wohnung_grundkosten_raumwaerme', 'wohnung_verbrauchskosten_raumwaerme', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit', 'wohnung_grundkosten_warmwasser',
        'wohnung_verbrauchskosten_warmwasser', 'wohnung_heizkosten_raumwaerme', 'wohnung_heizkosten_warmwasser'],
      other: ['warmwasser_messung', 'heiznebenkosten_messgeraet_art', 'heiznebenkosten_messgeraet_gemietet', 'heiznebenkosten_messgeraet_art_funk', 'warmwasser_temperatur',
        'gebaeude_grundkosten_raumwaerme', 'gebaeude_verbrauchskosten_raumwaerme', 'gebaeude_grundkosten_warmwasser',
        'gebaeude_verbrauchskosten_warmwasser']
    },
    'minol': {
      // basis: ['bewohneranzahl', 'wohnung_lage', 'warmwasser_bereitungsart', 'postleitzahl',  'gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe', 'abrechnungszeitraum', 'nutzungszeitraum'],
      ihre_kosten: ['wohnung_flaeche', 'wohnung_verbrauchseinheiten', 'wohnung_grundkosten_raumwaerme', 'wohnung_verbrauchskosten_raumwaerme', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit', 'wohnung_grundkosten_warmwasser',
        'wohnung_verbrauchskosten_warmwasser', 'wohnung_heizkosten_raumwaerme', 'wohnung_heizkosten_warmwasser'],
      kostenaufstellung: ['energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten'],
      berechnung_verteilung: ['prozent_raumwaerme', 'prozent_warmwasser', 'gebaeude_flaeche', 'warmwasser_verbrauch', 'warmwasser_einheit', 'gebaeude_heizkosten_warmwasser', 'gebaeude_heizkosten_raumwaerme',
        'gebaeude_heizkosten_gesamt', 'gebaeude_verbrauchseinheiten'],
      other: ['warmwasser_messung', 'heiznebenkosten_messgeraet_art', 'heiznebenkosten_messgeraet_gemietet', 'heiznebenkosten_messgeraet_art_funk', 'warmwasser_temperatur',
        'gebaeude_grundkosten_raumwaerme', 'gebaeude_verbrauchskosten_raumwaerme', 'gebaeude_grundkosten_warmwasser',
        'gebaeude_verbrauchskosten_warmwasser']
    },
    'kalo': {
      // basis: ['bewohneranzahl', 'wohnung_lage', 'warmwasser_bereitungsart', 'postleitzahl',  'gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe', 'abrechnungszeitraum', 'nutzungszeitraum'],
      kostenaufstellung: ['energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten'],
      verteilung_kosten: ['gebaeude_heizkosten_gesamt', 'gebaeude_heizkosten_warmwasser', 'prozent_warmwasser', 'warmwasser_verbrauch', 'warmwasser_einheit', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit',
        'wohnung_grundkosten_warmwasser', 'wohnung_verbrauchskosten_warmwasser', 'wohnung_heizkosten_warmwasser', 'gebaeude_heizkosten_raumwaerme', 'prozent_raumwaerme',
        'gebaeude_flaeche', 'wohnung_flaeche', 'gebaeude_verbrauchseinheiten', 'wohnung_verbrauchseinheiten', 'wohnung_grundkosten_raumwaerme', 'wohnung_verbrauchskosten_raumwaerme', 'wohnung_heizkosten_raumwaerme'],
      other: ['warmwasser_messung', 'heiznebenkosten_messgeraet_art', 'heiznebenkosten_messgeraet_gemietet', 'heiznebenkosten_messgeraet_art_funk', 'warmwasser_temperatur',
        'gebaeude_grundkosten_raumwaerme', 'gebaeude_verbrauchskosten_raumwaerme', 'gebaeude_grundkosten_warmwasser',
        'gebaeude_verbrauchskosten_warmwasser']
    },
    'bfw': {
      // basis: ['bewohneranzahl', 'wohnung_lage', 'warmwasser_bereitungsart', 'postleitzahl',  'gebaeudebaujahr', 'gebaeude_baualtersklasse_nutzerangabe', 'abrechnungszeitraum', 'nutzungszeitraum'],
      aufstellung_kosten: ['gebaeude_heizkosten_gesamt',  'gebaeude_heizkosten_warmwasser', 'gebaeude_heizkosten_raumwaerme', 'prozent_warmwasser', 'prozent_raumwaerme'],
      verteilung_kosten_heizung: ['gebaeude_flaeche',  'wohnung_flaeche', 'gebaeude_verbrauchseinheiten', 'wohnung_verbrauchseinheiten', 'wohnung_grundkosten_raumwaerme', 'wohnung_verbrauchskosten_raumwaerme', 'wohnung_heizkosten_raumwaerme'],
      verteilung_kosten_warmwasser: [ 'warmwasser_verbrauch', 'warmwasser_einheit', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit', 'wohnung_grundkosten_warmwasser', 'wohnung_verbrauchskosten_warmwasser', 'wohnung_heizkosten_warmwasser'],
      brennstoff: ['energietraeger_name', 'energietraeger_verbrauch', 'energietraeger_kosten'],
      other: ['warmwasser_messung', 'heiznebenkosten_messgeraet_art', 'heiznebenkosten_messgeraet_gemietet', 'heiznebenkosten_messgeraet_art_funk', 'warmwasser_temperatur',
        'gebaeude_grundkosten_raumwaerme', 'gebaeude_verbrauchskosten_raumwaerme', 'gebaeude_grundkosten_warmwasser',
        'gebaeude_verbrauchskosten_warmwasser']
    },
  };

  /**
   * list of fields that should trigger updates inside one step.
   */
  fieldsForFormChanges: string[] = ['wohnung_etage', 'obergeschoss', 'gebaeude_dachgeschoss_ausgebaut', 'energietraeger_name'];

  // list of water fields that are de/activated depending on the water heating type
  waterFields: string[] = ['warmwasser_verbrauch', 'warmwasser_einheit', 'wohnung_warmwasser_verbrauch', 'wohnung_warmwasser_einheit',
    'wohnung_grundkosten_warmwasser', 'wohnung_verbrauchskosten_warmwasser', 'gebaeude_heizkosten_warmwasser', 'prozent_warmwasser', 'wohnung_heizkosten_warmwasser'];

  /**
   * The options for some fields that are dynamic, depending on other form fields
   */
  static readonly options: any = {
    'heiznebenkosten_messgeraet_art_funk': {
      'zentral': ['nein', 'raumwaerme_warmwasser', 'raumwaerme', 'warmwasser'],
      'dezentral': ['nein', 'raumwaerme']
    }
  };

    /**
   * @inheritDoc
   * @param fieldId
   */
  getInfoPostfix(fieldId: string = null): string {
    // we want some extra help texts ins some cases for the heating bill path
    return '|heizkostenabrechnung';
  }

  /**
   * @inheritDoc
   * @param field
   */
  public hideField(field: FormModel): void {
    super.hideField(field);

    // toggle between gebaeudebaujahr and gebaeude_baualtersklasse_nutzerangabe
    switch(field.id) {
      case 'gebaeudebaujahr':
        this.activateField('gebaeude_baualtersklasse_nutzerangabe');
        break;
      case 'gebaeude_baualtersklasse_nutzerangabe':
        this.activateField('gebaeudebaujahr');
        break;
    }
  }

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: {[key: string]: any}): void {
    // activate field nutzergruppen in case nutzungszeitraum === nein
    if(values.hasOwnProperty('nutzungszeitraum') === true && values.nutzungszeitraum === 'nein') {
      this.activateField('nutzergruppen');
    }
    // in case of selection of the highest floor, show extra selection
    if(values.hasOwnProperty('wohnung_etage') === true && values.wohnung_etage === 'obergeschoss') {
      this.activateField('gebaeude_dachgeschoss_ausgebaut');
    }
    else {
      this.deactivateField('gebaeude_dachgeschoss_ausgebaut');
      values.gebaeude_dachgeschoss_ausgebaut = null;
    }

    // toggle between de/centralized water heating
    if(values.hasOwnProperty('warmwasser_bereitungsart')) {
      if(values.warmwasser_bereitungsart === 'zentral') {
        // show water fields

        for(const field of this.waterFields) {
          this.activateField(field);
        }
        this.setOptions('heiznebenkosten_messgeraet_art_funk', HeizkostenabrechnungForm.options.heiznebenkosten_messgeraet_art_funk['zentral']);
      }
      else {
        // water heating is done decentralized, hide some water fields
        for(const field of this.waterFields) {
          this.deactivateField(field);
          values[field] = null;
        }
        this.setOptions('heiznebenkosten_messgeraet_art_funk', HeizkostenabrechnungForm.options.heiznebenkosten_messgeraet_art_funk['dezentral']);
      }
    }

    // set gebaeudebaujahr and gebaeude_baualtersklasse_nutzerangabe
    if(values.hasOwnProperty("gebaeudebaujahr") && values.gebaeudebaujahr) {
      values.gebaeude_baualtersklasse_nutzerangabe = null;
      this.deactivateField('gebaeude_baualtersklasse_nutzerangabe');
      this.activateField('gebaeudebaujahr');
    }
    if(values.hasOwnProperty("gebaeude_baualtersklasse_nutzerangabe") && values.gebaeude_baualtersklasse_nutzerangabe) {
      values.gebaeudebaujahr = null;
      // this is a workaround because preseeting the select did not always work
      this.getField('gebaeude_baualtersklasse_nutzerangabe').setValue(values.gebaeude_baualtersklasse_nutzerangabe);
      this.deactivateField('gebaeudebaujahr');
      this.activateField('gebaeude_baualtersklasse_nutzerangabe');
    }

    // update energietraeger einheit options and set to first available option
    if(values.hasOwnProperty('energietraeger_name') === true) {
      this.setOptions('energietraeger_einheit', VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name]);

      // check if the (maybe) selected energy source is valid
      if(values.energietraeger_einheit && VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name]?.indexOf(values.energietraeger_einheit) === -1) {
        this.getField('energietraeger_einheit').setValue(VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0]);
        values.energietraeger_einheit = VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0];
        this.form.get('energietraeger_einheit').setValue(values.energietraeger_einheit);
      }
      if(!values.energietraeger_einheit) {
        // preset energy source
        this.getField('energietraeger_einheit').setValue(VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0]);
        values.energietraeger_einheit = VerbrauchsanalyseForm.options.energietraeger_einheit[values.energietraeger_name][0];
        this.form.get('energietraeger_einheit').setValue(values.energietraeger_einheit);
      }
    }

    // de/activate msp field if there was an analysis made or not
    if(this.anfrage.detectedData?.finished === true && Object.keys(this.anfrage.detectedData.fields).length > 0) {
      this.deactivateField('messdienstleister');
    }
    else {
      this.activateField('messdienstleister');
    }

    //check if "verdunster" is clicked and deactivate fields 'heiznebenkosten_messgeraet_gemietet' & 'heiznebenkosten_messgeraet_art_funk'
    if(values.hasOwnProperty("heiznebenkosten_messgeraet_art") === true) {
      if(values.heiznebenkosten_messgeraet_art === "verdunster") {
        this.deactivateField('heiznebenkosten_messgeraet_gemietet');
        this.deactivateField('heiznebenkosten_messgeraet_art_funk');
        values.heiznebenkosten_messgeraet_gemietet = null;
        values.heiznebenkosten_messgeraet_art_funk = null;
      }
      else {
        this.activateField('heiznebenkosten_messgeraet_gemietet');
        this.activateField('heiznebenkosten_messgeraet_art_funk');
      }
    }

    // show gebaeude_stockwerke for EnergyMap
    if (values.hasOwnProperty('postleitzahl') && typeof this.anfrage !== 'undefined') {
      if (this.energyMapService.showEnergyMap(this.anfrage, 'heizcheck') === true) {
        this.activateField('gebaeude_stockwerke');
      }
      else {
        this.deactivateField('gebaeude_stockwerke');
        values.gebaeude_stockwerke = null;
      }
    }
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected onChange() {
    // check if the form has some fields which value changes other fields.
    if(this.fieldsForFormChanges.find(field => this.form.get(field)) != undefined) {
      this.updateFields(this.getData());
    }
  }

  /**
   * @inheritDoc
   * Overwrite this function to sort the fields for each msp.
   * @param groupName
   */
  getFieldsFromGroup(groupName: string): FormModel[] {
    if((groupName === 'verbrauchseingabe' || groupName === 'kostendetails') && this.anfrage.heizkostenanalyseInput.messdienstleister) {
      // on these two steps, we sort the fields be the groupconfig
      const groupedFields = this.groupsConfig[this.anfrage.heizkostenanalyseInput.messdienstleister]?? this.groupsConfig['default'];
      const sortingArray = [].concat.apply([], Object.values(groupedFields));
      this.groups[groupName].sort((a, b) => sortingArray.indexOf(a) - sortingArray.indexOf(b));
    }

    return super.getFieldsFromGroup(groupName);
  }

}
